import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
  padding: 0 0 16px 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${colors.grey1};
`;
